



























































import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import Layout from '@/components/Layout.vue';
import logo from '@/assets/logo.png';
import Icon from '@/components/Icon.vue';
import dayjs from 'dayjs';
import clone from '@/lib/clone';
import Blank from '@/components/Blank.vue';

type Group = {
    name: string;
    items: RecordItem[];
}

@Component({
    components: {Blank, Icon, Layout}
})
export default class Bill extends Vue {
    logo: string = logo;
    year = window.sessionStorage.getItem('year') || dayjs().year().toString();
    month = window.sessionStorage.getItem('month') || (dayjs().month() + 1).toString();

    get years() {
        const endYear = dayjs().year();
        let y = 1970;
        const result: number[] = [];
        while (y <= endYear) {
            result.push(y);
            y++;
        }
        return result;
    }

    get recordList(): RecordItem[] {
        return this.$store.state.recordList;
    }

    get groupList() {
        const result: Group[] = [];
        const names: string[] = [];
        // 对记录排序
        const sortedRecordList = clone<RecordItem[]>(this.recordList).filter(item => (dayjs(item.createAt).year() === parseInt(this.year)) && (dayjs(item.createAt).month() + 1 === parseInt(this.month))).sort((b, a) => {
            return dayjs(a.createAt).valueOf() - dayjs(b.createAt).valueOf();
        });
        let record: RecordItem;
        for (record of sortedRecordList) {
            let date: string;
            if (this.year === dayjs().year().toString()) {
                // 今年的数据按天分组
                date = dayjs(record.createAt).toISOString().split('T')[0];
            } else {
                // 以前的数据按月分组
                date = dayjs(record.createAt).format('YYYY-MM');
            }

            const index = names.indexOf(date);
            if (index < 0) {
                names.push(date);
                result.push({name: date, items: [record]});
            } else {
                result[index].items.push(record);
            }
        }
        return result;
    }

    get totalIncome() {
        let total = 0;
        let group: Group;
        for (group of this.groupList) {
            let record: RecordItem;
            for (record of group.items) {
                if (record.type === '+') {
                    total += record.amount;
                } else {
                    continue;
                }

            }
        }
        return total;
    }

    get totalExpense() {
        let total = 0;
        let group: Group;
        for (group of this.groupList) {
            let record: RecordItem;
            for (record of group.items) {
                if (record.type === '-') {
                    total += record.amount;
                } else {
                    continue;
                }

            }
        }
        return total;
    }

    beautifyMonth(m: number) {
        return m < 10 ? '0' + m.toString() : m.toString();
    }

    toWeekday(value: number) {
        if (value >= 0 && value <= 6) {
            return [
                '星期天',
                '星期一',
                '星期二',
                '星期三',
                '星期四',
                '星期五',
                '星期六'
            ][value];
        }
    }

    getTitle(group: Group) {
        const day = dayjs(group.name);
        const now = dayjs();
        if (day.isSame(now, 'day')) {
            return `今天 ${this.toWeekday(day.day())}`;
        } else if (day.isSame(now.subtract(1, 'day'), 'day')) {
            return `昨天 ${this.toWeekday(day.day())}`;
        } else if (day.isSame(now.subtract(2, 'day'), 'day')) {
            return `前天 ${this.toWeekday(day.day())}`;
        } else if (day.isSame(now, 'year')) {
            return `${day.format('M月D日')} ${this.toWeekday(day.day())}`;
        } else {
            return `${day.format('YYYY年M月')}`;
        }
    }

    getTotal(group: Group) {
        let total = 0;
        let item: RecordItem;
        for (item of group.items) {
            if (item.type === '-') {
                total -= item.amount;
            } else if (item.type === '+') {
                total += item.amount;
            }
        }
        if (total <= 0) {
            return `支出: ¥${Math.abs(total)}`;
        } else {
            return `收入: ¥${Math.abs(total)}`;
        }
    }

    getAmount(record: RecordItem) {
        if (record.type === '+') {
            return record.amount;
        } else {
            return -record.amount;
        }
    }

    @Watch('year')
    saveYear(year: string) {
        window.sessionStorage.setItem('year', year);
    }
    @Watch('month')
    saveMonth(month: string) {
        window.sessionStorage.setItem('month', month);
    }
}
